export const AlertTriangule = (props) => {
  return (
    <svg
      {...props}
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.6909 35.5L27.4552 9.5C26.8695 8.5 25.8409 8 24.8123 8C23.7838 8 22.7552 8.5 22.1052 9.5L6.87661 35.5C5.77019 37.4929 7.23026 40 9.57947 40H40.0509C42.3909 40 43.8552 37.5 42.6909 35.5ZM10.2823 36.5714L24.748 11.7714L39.3409 36.5714H10.2823ZM24.8123 29.7929C23.5723 29.7929 22.5666 30.7986 22.5666 32.0386C22.5666 33.2786 23.5745 34.2843 24.8152 34.2843C26.0559 34.2843 27.058 33.2786 27.058 32.0386C27.0552 30.8 26.0552 29.7929 24.8123 29.7929ZM23.098 18.8571V25.7143C23.098 26.6643 23.8695 27.4286 24.8123 27.4286C25.7552 27.4286 26.5266 26.6607 26.5266 25.7143V18.8571C26.5266 17.9143 25.7623 17.1429 24.8123 17.1429C23.8623 17.1429 23.098 17.9143 23.098 18.8571Z"
        fill="#FFAE00"
      />
    </svg>
  )
}
